/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PublicCompanyResource } from '../models/PublicCompanyResource';
import type { PublicPersonnelResource } from '../models/PublicPersonnelResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PublicSignatureService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Informations d'un lien de signature
     * Page publique : pour le `token` du lien, renvoie l'entreprise, le devis (montants, commercial), ses fichiers (URLs signees temporaires) et les CGV a accepter. Si le devis est deja signe : `{ already_signed: true, company, signed_at, signer_name, files }`. 400 `{ message }` si le lien est expire, revoque, ou si le devis n'est plus signable (le lien est alors expire).
     * @param token
     * @returns any
     * @throws ApiError
     */
    public publicSignatureGetInfo(
        token: string,
    ): CancelablePromise<({
        token: string;
        company: PublicCompanyResource;
        commercial: (PublicPersonnelResource | null);
        devis: {
            id: string;
            numero: string;
            montant_ht: string;
            montant_ttc: string;
            description: string;
        };
        suggested_phones: (string | Array<string>);
        files: string;
        cgv: {
            id: string;
            url: string;
            display_name: string;
        };
    } | {
        already_signed: boolean;
        company: PublicCompanyResource;
        signed_at: string;
        signer_name: string;
        files: string;
    })> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/signature/{token}/info',
            path: {
                'token': token,
            },
        });
    }
    /**
     * Envoyer le code SMS de signature
     * Pour un lien de signature : verifie que le lien est valide et le devis signable, puis envoie un code a usage unique au `phone` fourni. 400 avec le message si le lien est expire ou le devis deja signe.
     * @param token
     * @param requestBody
     * @returns string
     * @throws ApiError
     */
    public publicSignatureSendOtp(
        token: string,
        requestBody: {
            phone: string;
        },
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/signature/{token}/send-otp',
            path: {
                'token': token,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Signer un devis depuis un lien public
     * `signer_name`, `phone` et `otp_code` (recu via `signature/{token}/send-otp`), plus `cgv_drive_file_id` si des CGV doivent etre acceptees (422 `CGV invalide` si l'identifiant n'est pas un CGV de l'entreprise). Verifie le code, signe le devis et ses fichiers, marque le lien signe et notifie l'entreprise. Reponse : `{ message, signed_at, files_signed }` ; 400 `{ message }` sur toute erreur.
     * @param token
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public publicSignatureSign(
        token: string,
        requestBody: {
            signer_name: string;
            phone: string;
            otp_code: string;
            cgv_drive_file_id?: number | null;
        },
    ): CancelablePromise<{
        message: string;
        signed_at: string;
        files_signed: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/signature/{token}/sign',
            path: {
                'token': token,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Erreur de validation`,
            },
        });
    }
}
